import "./style.css";

const DataLabel = ({ state, value }) => {
  switch (state) {
    case "pending":
      return <div className="order-dataLabel order-dataLabel-pending">{value}</div>;
    case "paid":
      return <div className="order-dataLabel order-dataLabel-success">Pagado</div>;
    default:
      return <div className="order-dataLabel order-dataLabel-pending">{state}</div>;
  }
};

export const OrderDetail = ({ text, value, label = null, icon, ext = "", className = "" }) => {
  return (
    <div className={"order-row " + className}>
      <div className="order-row-info">
        <div className="order-icon">{icon}</div>
        <div className="order-data">
          <div className="order-dataText">{text}</div>
          <div className="order-dataValue">
            {label === null ? (
              <>
                {value} {ext}
              </>
            ) : (
              <DataLabel state={label} value={`${value} ${ext}`} />
            )}
          </div>
        </div>
      </div>
      {/*<div className="order-row-action">{label !== null && <DataLabel state={label} />}</div>*/}
    </div>
  );
};

export const OrderDetailResumed = ({ content, className = "" }) => {
  return <div className={"order-row " + className}>{content}</div>;
};
